import { mount } from "@vue/test-utils";
import WorkActivity from "@/components/core/composite/combos/WorkActivity";

describe("WorkActivity component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(WorkActivity);
  });

  it("Renders del component AppFooter", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
